import { useQuery } from "hooks/useQuery";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTypedDispatch } from "store";
import { validateOrderFunc } from "store/users/thunkActions";

const OrderValidationScreen = () => {
  const dispatch = useTypedDispatch();
  const params = useQuery();
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      const orderId = params.get("oid");
      const productId = params.get("pid");
      if (orderId) {
        localStorage.setItem("oid", orderId);
      }
      if (orderId && productId) {
        await dispatch(validateOrderFunc(Number(orderId), Number(productId)));
        setTimeout(() => {
          navigate("/thank_you");
        }, 0);
      }
    };
    fetchData();
  }, [dispatch, navigate, params]);
  return <div></div>;
};

export default OrderValidationScreen;
